import React, { useState } from "react";
import styles from "./index.module.css";
import { ChevronDown } from "lucide-react";

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
}

const Accordion = ({ title, children, icon }: AccordionProps) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className={styles.accordionItem}>
      <button
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
        onClick={() => setIsActive(!isActive)}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
          className={styles.link}
        >
          {icon && <span className={styles.icon}>{icon}</span>}
          {title}
        </span>
        <ChevronDown className={`${styles.chevron} ${isActive ? styles.rotate : ""}`} size={16} />
      </button>
      <div className={`${styles.accordionContent} ${isActive ? styles.show : ""}`}>{children}</div>
    </div>
  );
};

export default Accordion;
